import {
  CarrotAdBaseEntity,
  CarrotAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";
import { CarrotTypes } from "@shared/services/event_tracking/carrot_tracking";

interface CarrotShoppableUnitAdEntityParams extends CarrotAdBaseEntityParams {
  interaction_id: string;
  forward_url: string;
  creative_type: string;
  asset_type: string;
}

export class CarrotShoppableUnitAdEntity extends CarrotAdBaseEntity {
  click_interaction_id: string;
  forward_url: string;
  creative_type: string;
  asset_type: string;

  constructor(params: CarrotShoppableUnitAdEntityParams) {
    super(params);
    this.type = CarrotTypes.ShoppableUnit;
    this.entity_version = 2;
    this.click_interaction_id = params.interaction_id;
    this.forward_url = params.forward_url;
    this.creative_type = params.creative_type;
    this.asset_type = params.asset_type;
  }
}
